import { Navigate, useLocation } from "react-router-dom";

export default function CompensationProfilesCreateRedirect() {
  const location = useLocation();
  // Redirect from /people/:pgaId/career/compensation-profiles/create to /people/:pgaId/career/compensation/create
  const newPath = location.pathname.replace("/compensation-profiles/", "/compensation/");
  return <Navigate to={`${newPath}${location.search}`} replace />;
}
